import httpClient from '../httpClient';

export async function getTicket(id: string) {
  try {
    const response = await httpClient.get(`/api/tickets/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Produto DAF: ' + error);
  }
}

export async function getAllTickets() {
  try {
    const response = await httpClient.get(`/api/tickets`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Documentos SisAF: ' + error);
  }
}
